import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, AppointmentCoachRole, AppointmentCoachRoleWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAppointmentCoachRole(): UseMutationResult<
  AxiosResponse<AppointmentCoachRole>,
  AxiosError<ErrorMessage>,
  AppointmentCoachRoleWrite
> {
  const queryClient = useQueryClient();

  const createAppointmentCoachRole = (
    appointmentCoachRole: AppointmentCoachRoleWrite,
  ): Promise<AxiosResponse<AppointmentCoachRole>> => {
    return client.post('appointment-coach-roles/', appointmentCoachRole);
  };

  return useMutation(createAppointmentCoachRole, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['appointmentCoachRoles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['appointmentPayRateLookups'],
      });
    },
  });
}
